import React from "react";
import LoginForm from "./LoginForm";
// import Logo from "./components/Logo";
import feedgramLogo from "./branding/thefeedgram.svg";
// import { Link } from "found";
import { Link } from "react-router-dom";
import logoRed from "./branding/thefeedgram.svg";
import "./AuthPage.css";
import ThemeProvider from "./contexts/ThemeContext";
// import "./LoginPage.css";

class LoginPage extends React.Component {
    render() {
        return (
            <div className="login-container">
                <ThemeProvider>
                    <div className="login-header">
                        <div className={`login-header-room`}>
                            <div className="component-box">
                                <Link to="/">
                                    <img
                                        className="brand-logo"
                                        src={logoRed}
                                        alt=""
                                    />
                                </Link>
                                <Link
                                    className="login-link"
                                    to="/signup"
                                >
                                    Sign up
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className={`login-form-container`}>
                        <LoginForm />
                    </div>
                    <div className="terms-conditions">
                        <a
                            href="https://docs.thefeedgram.com/docs/terms/terms/"
                            target="_blank"
                        >
                            Terms
                        </a>
                        <a
                            href="https://docs.thefeedgram.com/docs/terms/privacy/"
                            target="_blank"
                        >
                            Privacy
                        </a>
                        <a
                            href="https://docs.thefeedgram.com/docs/help/support/"
                            target="_blank"
                        >
                            {" "}
                            Help & Feedback
                        </a>
                    </div>
                </ThemeProvider>
            </div>
        );
    }
}

export default LoginPage;
